import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useLang } from "@/contexts/LanguageContext";

export default function ForgotPassword() {
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [result, setResult] = useState(null);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr(""); setResult(null);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setResult(data);
    } catch (e2) {
      setErr(formatApiErrorDetail(e2.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-16 lg:py-24">
      <p className="eyebrow">{t.auth.forgotTitle}</p>
      <h1 className="font-serif text-3xl sm:text-4xl mt-3 text-[#0B192C]">{t.auth.forgotTitle}</h1>
      <p className="mt-2 text-slate-500 text-sm">{t.auth.forgotSubtitle}</p>

      <form onSubmit={onSubmit} className="mt-8 space-y-5" data-testid="forgot-form">
        <div>
          <label className="label-elegant">{t.auth.email}</label>
          <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="input-elegant" data-testid="forgot-email" />
        </div>
        {err && <p className="text-sm text-red-600" data-testid="forgot-error">{err}</p>}
        <button disabled={busy} type="submit" className="btn-primary w-full justify-center disabled:opacity-60" data-testid="forgot-submit">{t.auth.send}</button>
      </form>

      {result && (
        <div className="mt-8 p-5 border border-slate-200 rounded-xl bg-[#F8F9FA]" data-testid="forgot-result">
          <p className="text-sm text-slate-600">{t.auth.simulatedEmailNote}</p>
          {result.reset_link && (
            <a href={result.reset_link} className="btn-outline mt-4 inline-flex text-sm" data-testid="forgot-open-link">
              {t.auth.openLink}
            </a>
          )}
        </div>
      )}

      <p className="mt-8 text-sm text-slate-500">
        <Link to="/login" className="text-[#0B192C] underline underline-offset-4">{t.auth.signIn}</Link>
      </p>
    </div>
  );
}
